import React from 'react'

import { MeasureSummary } from '../ViewScorecardSummary/ViewScorecardSummary'

export const ScorecardCriteriaSummary = ({ section, measureDraft }) => {
  return (
    <div className="scorecard-summary" data-testid="view-scorecard-summary">
      <div className="scorecard-summary__section-summary" data-testid="section-summary">
        <h2 className="scorecard-summary__section-title">{section.name}</h2>
        <div className="scorecard-summary__measure-container">
          <MeasureSummary measure={measureDraft} key={measureDraft.name} />
        </div>
      </div>
    </div>
  )
}
